export class EmailModel {
    toEmail: string;
    fromEmail: string;
    fromName?: string;
    pdfHtml: string;
    Subject: string;
  header_id: string | number;
    entity_id: string;
    body: string;
    activity_message: string;
    FileName: string;
    includeAttachment: boolean;
  attachment: any;
  print_orientation: string;
  batch_type_id: string;
  convert_attachment_to: string;

}
